var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import React from 'react';
import ViewNavigation from '../components/ViewNavigation';
var MonthsView = /** @class */ (function (_super) {
    __extends(MonthsView, _super);
    function MonthsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._updateSelectedMonth = function (event) {
            _this.props.updateDate(event);
        };
        return _this;
    }
    MonthsView.prototype.render = function () {
        return (_jsxs("div", { className: "rdtMonths", children: [_jsx("table", { children: _jsx("thead", { children: this.renderNavigation() }) }), _jsx("table", { children: _jsx("tbody", { children: this.renderMonths() }) })] }));
    };
    MonthsView.prototype.renderNavigation = function () {
        var _this = this;
        var year = this.props.viewDate.year();
        return (_jsx(ViewNavigation, { onClickPrev: function () { return _this.props.navigate(-1, 'years'); }, onClickSwitch: function () { return _this.props.showView('years'); }, onClickNext: function () { return _this.props.navigate(1, 'years'); }, switchContent: year, switchColSpan: "2" }));
    };
    MonthsView.prototype.renderMonths = function () {
        // 12 months in 3 rows for every view
        var rows = [[], [], []];
        for (var month = 0; month < 12; month++) {
            var row = getRow(rows, month);
            row.push(this.renderMonth(month));
        }
        return rows.map(function (months, i) { return _jsx("tr", { children: months }, i); });
    };
    MonthsView.prototype.renderMonth = function (month) {
        var selectedDate = this.props.selectedDate;
        var className = 'rdtMonth';
        var onClick;
        if (this.isDisabledMonth(month)) {
            className += ' rdtDisabled';
        }
        else {
            onClick = this._updateSelectedMonth;
        }
        if (selectedDate && selectedDate.year() === this.props.viewDate.year() && selectedDate.month() === month) {
            className += ' rdtActive';
        }
        var props = { key: month, className: className, 'data-value': month, onClick: onClick };
        if (this.props.renderMonth) {
            return this.props.renderMonth(props, month, this.props.viewDate.year(), this.props.selectedDate && this.props.selectedDate.clone());
        }
        return _jsx("td", __assign({}, props, { children: this.getMonthText(month) }));
    };
    MonthsView.prototype.isDisabledMonth = function (month) {
        var isValidDate = this.props.isValidDate;
        if (!isValidDate) {
            // If no validator is set, all days are valid
            return false;
        }
        // If one day in the month is valid, the year should be clickable
        var date = this.props.viewDate.clone().set({ month: month });
        var day = date.endOf('month').date() + 1;
        while (day-- > 1) {
            if (isValidDate(date.date(day))) {
                return false;
            }
        }
        return true;
    };
    MonthsView.prototype.getMonthText = function (month) {
        var localMoment = this.props.viewDate;
        var monthStr = localMoment.localeData().monthsShort(localMoment.month(month));
        return capitalize(monthStr.substring(0, 3));
    };
    return MonthsView;
}(React.Component));
export default MonthsView;
function getRow(rows, year) {
    if (year < 4) {
        return rows[0];
    }
    if (year < 8) {
        return rows[1];
    }
    return rows[2];
}
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
